export const ICON_ROOT_FOLDER = '/library/svgIcons/';
